module.exports = "/assets/logo_sg_dreamweaver_1_1-df1b8536a6c721877ccc486e0bc5bb23.png";